import request from '@/config/axios'

export const getIntelBriefPage = (params: any) =>
  request.get({ url: '/bosscircle/intel-brief/page', params })
export const getIntelBrief = (id: number) =>
  request.get({ url: '/bosscircle/intel-brief/get', params: { id } })
export const ignoreIntelBrief = (data: any) =>
  request.put({ url: '/bosscircle/intel-brief/ignore', data })
